import * as React from 'react';
import { CircledCrossIcon, CircledFilledCheckIcon, LayersIcon } from '../Icons';
import { Event, Filespace } from 'fs-api-client';
import { emitToWebservice } from '../../../utils/utilFunctions';
import { RouteComponentProps, withRouter } from 'react-router-dom';

interface RenameFilespaceModalProperties extends RouteComponentProps {
    filespace: Filespace;
    domainName: string;
    userEmail: string;
}

interface RenameFilespaceModalState {
    canContinue: boolean;
}

class RenameFilespaceModal extends React.Component<RenameFilespaceModalProperties, RenameFilespaceModalState> {
    constructor(props: any) {
        super(props);

        this.handleContinueClicked = this.handleContinueClicked.bind(this);
        this.openRenameWizard = this.openRenameWizard.bind(this);
        this.state = { canContinue: false };
    }

    render() {
        return (
            <div data-backdrop="static" data-keyboard="false" className="modal fade initModal" id="renameFilespaceModal" tabIndex={-1} role="dialog" aria-labelledby="renameFilespaceModal" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg modal-lg-plus" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <LayersIcon className="svg__modal orange" width="36px" height="36px" />
                            <h2 className="modal-title">
                                Rename the Filespace<br />
                                <span>{`${this.props.filespace.name}.${this.props.domainName}`}</span>
                            </h2>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">
                                    <CircledCrossIcon width="20px" height="20px" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body bullet">
                            <ul>
                                <li>
                                    <div className="icon">
                                        <CircledFilledCheckIcon className="checkmark orange" width="18px" height="18px" />
                                    </div>
                                    <p>
                                        <strong>During the renaming process, the Filespace will not be accessible.</strong>
                                        Before you begin, please disconnect the Filespace from all connected devices.
                                    </p>
                                </li>
                                <li>
                                    <div className="icon">
                                        <CircledFilledCheckIcon className="checkmark orange" width="18px" height="18px" />
                                    </div>
                                    <p>
                                        <strong>Larger Filespaces will take longer for the renaming process to complete.</strong>
                                        Process times will range from just a few minutes to as much as 30 minutes.
                                    </p>
                                </li>
                                <li>
                                    <div className="icon">
                                        <CircledFilledCheckIcon className="checkmark orange" width="18px" height="18px" />
                                    </div>
                                    <p>
                                        <strong>Let your team know when it’s time to reconnect.</strong>
                                        Once the renaming process is complete, users can reconnect using the new Filespace name. 
                                    </p>
                                </li>
                            </ul>
                            <div className="checkboxWrapper">
                                <div className="checkbox">
                                    <input
                                        id="continueSelector"
                                        name="continueSelector"
                                        type="checkbox"
                                        checked={this.state.canContinue}
                                        onChange={this.handleContinueClicked}
                                    />
                                    <label htmlFor="continueSelector">I acknowledge and understand these notes above.</label>
                                </div>
                            </div>
                            <footer>
                                Need more info? Please read our knowledge base article about <a href="https://www.lucidlink.com/filespace-rename" target="_blank">renaming your Filespace</a>.
                            </footer>
                        </div>
                        <div className="modal-footer">
                            <button type="button" disabled={!this.state.canContinue} className="btn-short green launch-marker" data-dismiss="modal" id="launch" onClick={this.openRenameWizard}>Next</button>
                            <button type="button" className="link btn-short launch-cancel-marker" data-dismiss="modal">Cancel</button>
                        </div>
                    </div>
                </div>
        </div>
        );
    }

    private openRenameWizard() {
        emitToWebservice(
            `Clicked the webportal “Rename Filespace” button to rename filespace ${this.props.filespace.name}.${this.props.domainName}`,
            Event.LogTypeEnum.Log,
            Event.EventTypeEnum.Filespace
        );
        this.props.history.push(
            `/dashboard/renameFilespace?${this.props.filespace.id}&${this.props.filespace.name}&${this.props.userEmail}`
        );
    }

    private handleContinueClicked(e: any) {
        this.setState({ canContinue: e.target.checked });
    }
}

const RenameFilespaWithRouter = withRouter(RenameFilespaceModal);
export { RenameFilespaWithRouter as RenameFilespaceModal };


// WEBPACK FOOTER //
// ./src/webportal/components/common/modals/RenameFilespaceModal.tsx